import {
  useStyle 
} from "@/classify"
import {
  Input as InformedText, useFieldApi 
} from "informed"
import React, {
  useImperativeHandle 
} from "react"
import {
  FieldIcons 
} from "../Field"
import defaultClasses from "./textInput.module.css"

// eslint-disable-next-line react/display-name
const TextInput = React.forwardRef((props, ref) => {
  const {
    after,
    before,
    classes: propClasses,
    children,
    name,
    fieldIconsClasses = {},
    ...rest
  } = props

  const classes = useStyle(defaultClasses, propClasses)

  const fieldApi = useFieldApi(name)

  useImperativeHandle(ref, () => ({
    fieldApi,
  }))

  return (
    <FieldIcons after={after} before={before}
      classes={fieldIconsClasses}
    >
      <InformedText
        className={classes.input}
        validateOn='submit'
        {...rest}
      />
    </FieldIcons>
  )
})

export default TextInput
